import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";
import { StoreButtons } from "@/components/landing/StoreButtons";
import { optimizeImg } from "@/lib/img";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={optimizeImg(IMAGES.hero, 1920)} alt="Athlete training at night" fetchPriority="high" decoding="async" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-obsidian/60" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 w-full pt-44 md:pt-40 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="max-w-2xl"
        >
          <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.25em] uppercase text-vitality mb-6">
            <span className="w-8 h-px bg-vitality" /> Train Smarter · Eat Better · Stay Connected
          </span>

          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black uppercase leading-[0.92] tracking-tight">
            Transform Your Body.
            <br />
            <span className="text-vitality text-glow">Fuel Your Life.</span>
          </h1>

          <p className="mt-6 text-lg text-white/70 max-w-xl leading-relaxed">
            AlphaPulse is your all-in-one fitness platform — personalized workouts, intelligent nutrition,
            real-time progress tracking and a community that pushes you forward. Power your evolution from start to finish.
          </p>

          <div className="mt-9">
            <StoreButtons />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
